import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTypedSelector } from '@redux/Hooks/storeSelectors';
import { selectMapLayerIdByEntityName } from '@redux/selectors/selectors';
import EntityManagerCleaner from '../../../entities/EntityManagerCleaner';
import EntityEditor from '../../../entities/EntityEditor';
import { RoadInfrastructureEntityName } from '@api/types/types';

const DistrictEdit = () => {
    const entityName = RoadInfrastructureEntityName.District;
    const { districtId } = useParams<any>();
    const districtsLayerId = useTypedSelector(state =>
        selectMapLayerIdByEntityName(state, entityName)
    );

    const onSaveFn = useCallback(
        (entity: any) => {
            if (!districtId) {
                return `../${entity.id}/edit`;
            }
        },
        [districtId]
    );

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={districtId!}
                entityName={entityName}
                layerId={districtsLayerId}
                presetProperty={'roadInfrastructurePreset'}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!districtId}
            />
        </EntityManagerCleaner>
    );
};

export default DistrictEdit;
